import { useEffect, useState, React } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom"
//Styles
import "./Global.css"
import "./App.css"
//Gloabal auth via user
import { useAuthContext } from "./Hooks/useAuthContext"
//Components
import TopNav from "./Components/Navigation/TopNav"
import Home from "./Pages/Home"
import Branding from "./Pages/Branding"
import LoginForm from "./Components/LoginForm"

import Users from "./Pages/Users/Users.js"
import Farms from "./Pages/Farms/Farms.js"
import Projects from "./Pages/Projects/Projects.js"
import Calendar from "./Pages/Calendar/Calendar.js"


import RequestResetPassword from "./Pages/RequestResetPassword.js"
import ResetPassword from "./Pages/Users/ResetPassword.js"

// Background Image
import backgroundImage from "./Images/background.jpg"

function App() {

    const { dispatch, user } = useAuthContext()

    const [form, setForm] = useState({
    });

    const setField = (field, value) => {
        setForm({
            ...form,
            [field]: value,
        });
    };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"))
    if (user) {
      dispatch({ type: "WELCOMEBACK", payload: user })
    }
  }, [dispatch])

  return (
    <BrowserRouter>
        <div className="app"  style={{backgroundImage: `url(${backgroundImage})`, backgroundSize: "cover"}}>
            <div className="container">
            
            {!user && (
                <Routes>
                    <Route path="/ResetPassword" element={<RequestResetPassword />} />
                    <Route path="/Users/:userId/ResetPassword/:confirmationCode" element={<ResetPassword />} />
                    <Route path="*" element={<LoginForm />} />
                </Routes>
            )}
            {user && (
                <div>
                    <TopNav />
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/Users/*" element={<Users />} />
                            <Route path="/Farms/*" element={<Farms />} />
                            <Route path="/Projects/*" element={<Projects />} />
                            <Route path="/Calendar/*" element={<Calendar />} />
                


                            {/* Dont forget to remove this!! */}
                            <Route path="/Branding" element={<Branding />} />

           
                        </Routes>
                </div>
            )}
            </div>
        </div>
    </BrowserRouter>
  )
}

export default App
